export default "__VITE_ASSET__CQlQT6PN__"